var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSpring = function SvgSpring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 62v-4a2 2 0 00-2-2H61a2 2 0 00-2 2v4a2 2 0 002 2h41a2 2 0 002-2zM59 62v-4a2 2 0 00-2-2H18a2 2 0 00-2 2v4a2 2 0 002 2h39a2 2 0 002-2z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64v-8H28v8h31zM90 64v-8H59v8h31z",
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61 65V55a2 2 0 10-4 0v10a2 2 0 104 0zM21 68V52a2 2 0 00-2-2h-1a2 2 0 00-2 2v16a2 2 0 002 2h1a2 2 0 002-2zM104 68V52a2 2 0 00-2-2h-1a2 2 0 00-2 2v16a2 2 0 002 2h1a2 2 0 002-2z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 56v8M63 56v8M34 56v8M66 56v8M37 56v8M69 56v8M40 56v8M72 56v8M43 56v8M75 56v8M46 56v8M78 56v8M49 56v8M81 56v8M52 56v8M84 56v8M55 56v8M87 56v8",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};

export default SvgSpring;